export default "__VITE_ASSET__D0bOx8Eh__"